// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-l_gQ","advertDetailContactItem__link":"c-l_gR","advertDetailContactItem__stub":"c-l_gS"};